<template>
  <span>
    {{ profiles[profile] }}
  </span>
</template>

<script>
export default {
  props: {
    profile: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      profiles: {
        trader: 'Promotor',
        investor: 'Investidor',
        consumer: 'Consumidor',
      },
    };
  },
};
</script>
